/*
 *
 * Announcement
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import InitialSnackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import {withStyles} from "@material-ui/core/styles";
import classNames from 'classnames';


const styles1 = theme => ({
        success: {
            backgroundColor: green[600],
        },
        error: {
            backgroundColor: theme.palette.error.dark,
        },
        info: {
            backgroundColor: '#e5e5e9',
            color: 'black',
            display: 'flex',
            flexDirection: "row",
            flexWrap: "nowrap",
            alignItems: "flex-start",
            padding: '0px 3px 0px 12px',
        },
        iconVariant: {
            opacity: 0.9,
            marginRight: theme.spacing.unit,
        },
        messageContainer: {
            display: "flex",
            flexDirection: "column",
            gap: '10px'
        },
        link: {
            color: '#2727ff', textDecoration: 'underline', cursor: "pointer"
        }
    }
);

function MySnackbarContent(props) {
    const {
        classes, className, id, name, onClose, variant, showAnnouncementDialog, removeAnnouncement
    } = props;

    const handleLinkClick = () => {
        showAnnouncementDialog()
        onClose()
    }

    const handleClose = (id) => {
        onClose()
        removeAnnouncement(id)
    }


    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <div className={classes.messageContainer}>
                    <span id="client-snackbar">{name}</span>
                    <span className={classes.link} onClick={handleLinkClick}>Подробнее здесь</span>
                </div>
            }
            action={[
                <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={() => handleClose(id)}
                >
                    <CloseIcon className={classes.icon}/>
                </IconButton>,
            ]}
        />
    );
}

MySnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};


const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class AnnouncementBar extends React.PureComponent {
    render() {
        const {
            announcement: {openBar, id, name, content},
            onClose,
            showAnnouncementDialog,
            removeAnnouncement,
        } = this.props;

        return (
            <InitialSnackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={openBar}>
                <MySnackbarContentWrapper
                    onClose={onClose}
                    variant="info"
                    id={id}
                    name={name}
                    content={content}
                    showAnnouncementDialog={showAnnouncementDialog}
                    removeAnnouncement={removeAnnouncement}
                />
            </InitialSnackbar>
        );
    }
}

AnnouncementBar.propTypes = {
    announcement: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    showAnnouncementDialog: PropTypes.func.isRequired,
};

export default AnnouncementBar;
